module.exports = __webpack_public_path__ + "img/bg_banner.6d552fe0.png";